import React from "react";
import { useTranslation } from "react-i18next";
import GroupSelector from "./GroupSelector";
import AlertMessage from "./AlertMessage";

const SearchSection = ({
  showAlert,
  searchFilters,
  setSearchFilters,
  isGroupDropdownOpen,
  setIsGroupDropdownOpen,
  groupSearchInput,
  setGroupSearchInput,
  productGroup,
  filteredGroupOptions,
  dropdownRef,
}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "fa"; // Check if language is Farsi
  const groupPageSearchInput = isRTL ? "groupPage-searchInput-fa" : "groupPage-searchInput";

  return (
    <div className="groupPage-search-container">
      <div className="groupPage-search-alert">
        <AlertMessage showAlert={showAlert} />
      </div>
      <div className="search-filters-container-box">
        <div className="search-filters">
          <GroupSelector
            searchFilters={searchFilters}
            setSearchFilters={setSearchFilters}
            isGroupDropdownOpen={isGroupDropdownOpen}
            setIsGroupDropdownOpen={setIsGroupDropdownOpen}
            groupSearchInput={groupSearchInput}
            setGroupSearchInput={setGroupSearchInput}
            productGroup={productGroup}
            filteredGroupOptions={filteredGroupOptions}
            dropdownRef={dropdownRef}
          />
        </div>
        <div className="search-filters search-filters2">
          <input
            type="text"
            placeholder={t("groupPage_search_placeholder")}
            value={searchFilters.productGroupId}
            onChange={(e) => {
              setSearchFilters((prev) => ({
                ...prev,
                productGroupId: e.target.value,
                productGroupENName: e.target.value,
              }));
            }}
            className={groupPageSearchInput}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchSection;
